const navbarLinks = [
  {
    category: "Home",
    link: "/",
    links: [],
  },
  {
    category: "Lotus K-4 After School Club",
    link: "/606atLotus",
    links: [],
  },
  {
    category: "Basketball",
    link: "#",
    links: [
      {
        name: "Nov 21 Open House",
        url: "/BasketballOpenHouse",
      },
      {
        name: "K-2nd Grade BBall League",
        url: "/BasketballLeague",
      },
      {
        name: "3rd-4th Grade BBall League",
        url: "/BasketballLeague",
      },
    ],
  },
  {
    category: "Donate",
    link: '/Sponsor',
    links: [],
  },
  {
    category: "About Us",
    link: "#",
    links: [
      {
        name: "Our Story",
        url: "/About",
      },
      {
        name: "Meet the Team",
        url: "/team",
      },
      {
        name: "Our Values",
        url: "/Values",
      },
    ],
  },
  {
    category: "What We Offer",
    link: "#",
    links: [
      {
        name: "Enrichment",
        url: "/Enrichment",
      },
      {
        name: "1 Day Holiday Camps",
        url: "/Holiday",
      },
      {
        name: "Week Long School Break Camps",
        url: "/WeekCamps",
      },
      {
        name: "Peewee Clinics - Ages 3-5",
        url: "/Peewee",
      },
    ],
  },
  {
    category: "Now Hiring",
    link: '/Employment',
    links: [],
  },
  {
    category: "Contact Us",
    link: '/ContactUs',
    links: [],
  }
];


export { navbarLinks };